<template>
  <form class="page-colors" @submit.prevent="submit">

    <!-- TODO: Get current colour from site and apply active state -->

    <div>
      <Field
        label="Color"
        hidden
        @input="$v.resource.background_color.$touch()"
        v-model="resource.background_color"
        :error="background_colorError"
        :options="colors"/>
    </div>

    <div class="colors">
      <div
        v-for="(color, index) in colors"
        :key="`color-${index}`"
        :class="{'is-active': activeClass(color.value)}"
        :style="{background: color.value}"
        @click="setBackground(color)">
      </div>
    </div>

    <hr>

    <div class="btn-save">
      <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'SiteColorForm',

  mixins: [form],

  data() {
    return {
      activeColor: ''
    }
  },

  components: {
    Btn
  },

  props: {
    colors: {
      type: Array,
      required: true
    },

    companyId: String,
    siteId: String
  },

  computed: {
    ...errorMessages([
      'background_color'
    ]),

    activeClass() {
      return (color) => {
        return color === this.activeColor
      }
    }
  },

  validations: {
    resource: {
      background_color: {required}
    }
  },

  methods: {
    setBackground(color) {
      this.resource.background_color = color.value
      this.activeColor = color.value
      this.$emit('setBackground', color)
      this.changesMade = true
    }
  }
}
</script>

<style lang="sass">
  .page-colors
    .colors
      display: flex
      flex-wrap: nowrap
      justify-content: space-evenly

      div
        cursor: pointer
        width: 30px
        height: 30px
        margin: 8px
        border-radius: 50%
        border: 3px solid rgba(0, 0, 0, 0.05)
        transition: all .2s ease-in-out
        overflow: hidden
        position: relative

        &:before, &:after
          content: ''
          position: absolute
          width: 50%
          height: 100%

        &:before
          background: rgba(255, 255, 255, 0.6)
          right: 0

        &:after
          background: rgba(0, 0, 0, 0.25)
          top: 0

        &.is-active
          transform: scale(1.5)
          border: 3px solid rgba(0, 0, 0, 0.2)
</style>
